<template>
  <el-dialog
    v-model="showConsent" 
    title=" "
    width="450px"
    :close-on-click-modal="false" 
    :before-close="handleClose"
    :visible.sync="showConsent"
    :show-close="false"
    center
  >
    <!-- 整体居中div -->
    <div style="text-align: center;">
      <img src="@/assets/img/cookie.svg" alt="cookie" style="width: 100px; height: 100px; display: block; margin: 0 auto; margin-bottom: 20px;">
      <h3 style="color:black; display: block; margin: 0 auto; margin-bottom: 20px;" ><b>We use cookies</b></h3>
      To ensure you get the best experience on T2T-Hub. 
      <p></p>By clicking "Accept", you agree to store cookies on your device.
    </div>
    <template #footer>
      <el-button @click="rejectCookies" type="warning"><b>Reject</b></el-button>
      <el-button @click="acceptCookies" type="primary"><b>Accept</b></el-button>
      
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      showConsent: false,  // 控制弹框显示
    };
  },
  created() {
    // console.log("cookieConsent in localStorage:", localStorage.getItem("cookieConsent"));
    // 检查是否有用户同意信息
    const consent = localStorage.getItem("cookieConsent");
    if (consent != "accepted") {
      this.showConsent = true;  // 如果没有同意，显示弹框
    }
  },
  methods: {
    acceptCookies() {
      localStorage.setItem("cookieConsent", "accepted");  // 存储同意状态
      this.showConsent = false;  // 隐藏弹框
    },
    handleClose(done) {
      done();
    },
    rejectCookies() {
      localStorage.setItem("cookieConsent", "rejected");  // 存储拒绝状态
      this.showConsent = false;  // 隐藏弹框
    },

  },
};
</script>

<style scoped>
.el-dialog {
  z-index: 9999;
}

/* Custom styling for the dialog to appear at the bottom */
.cookie-consent-dialog .el-dialog__wrapper {
  position: fixed;
  bottom: 20px;  /* Adjust distance from the bottom */
  left: 50%;
  transform: translateX(-50%);
  margin: 0; /* Remove any default margin */
}
</style>
